// @flow

import { Component } from '../jsti/core';
import EventNames from '../constants/EventNames';

export default class RatingStars extends Component {
  #clickHandler: function;

  activeClass: string = 'rating--active';
  hoverClass: string = 'rating--focused';
  errorClass: string = 'stroke-red';
  stars: Array<HTMLInputElement>;
  starImages: Array<SVGElement>;

  /**
   * Initialize the component
   */
  bind(el: HTMLElement): void {
    super.bind(el);

    this.stars = [...this.el.getElementsByRef('score')];
    this.starImages = [...this.el.getElementsByRef('star')];

    this.#clickHandler = this.onClick.bind(this);

    this.addEventListener(EventNames.MOUSE_OVER, this.onHover.bind(this));
    this.addEventListener(EventNames.MOUSE_LEAVE, this.onHoverOut.bind(this));
    this.stars.forEach((star: HTMLInputElement) => {
      star.addEventListener(EventNames.CLICK, this.#clickHandler);
    });
  };

  /**
   * Executes on click
   */
  onClick(e: Event): void {
    if (!(e.target instanceof HTMLInputElement)) return;
    const value: number = +e.target.defaultValue;

    this.removeErrorClasses();

    this.stars.forEach((star: HTMLInputElement) => {
      star.classList.remove(this.activeClass);
      if (+star.value <= value) {
        star.classList.add(this.activeClass);
      }
    });
  }

  /**
   * Executes on hover
   */
  onHover(e: Event): void {
    if (!(e.target instanceof HTMLInputElement)) return;
    const value: number = +e.target.defaultValue;

    this.stars.forEach((star: HTMLInputElement) => {
      star.classList.remove(this.hoverClass);
      if (+star.value <= value) {
        star.classList.add(this.hoverClass);
      }
    });
  }

  /**
   * Executes on mouse leave
   */
  onHoverOut(): void {
    this.stars.forEach((star: HTMLInputElement) => {
      star.classList.remove(this.hoverClass);
    });
  }

  removeErrorClasses(): void {
    this.starImages.forEach((star: SVGElement) => {
      star.classList.remove(this.errorClass);
    });
  }

  /**
   * Destroy all event listeners
   */
  destroy() {
    this.stars.forEach((star: HTMLInputElement) => star.removeEventListener(EventNames.CLICK, this.#clickHandler));
    super.destroy();
  }
}
